"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _designTokens = _interopRequireDefault(require("@decisiv/design-tokens"));

var _useTranslations = _interopRequireDefault(require("../../utils/useTranslations"));

var _Button = _interopRequireDefault(require("../Button"));

var _Flex = _interopRequireDefault(require("../Flex"));

var _Typography = require("../Typography");

var _schema = _interopRequireDefault(require("./schema"));

var _utils = require("./utils");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var JumpToOl = (0, _styledComponents.default)(_Flex.default).attrs({
  as: 'ol',
  alignItems: 'center'
}).withConfig({
  displayName: "JumpToNav__JumpToOl",
  componentId: "sc-1a5y6a1-0"
})(["margin:0;padding:0;"]);
var JumpToLi = (0, _styledComponents.default)(_Flex.default).attrs({
  as: 'li',
  alignItems: 'center'
}).withConfig({
  displayName: "JumpToNav__JumpToLi",
  componentId: "sc-1a5y6a1-1"
})(["padding:0;&:not(:first-of-type){margin-left:", ";}"], (0, _rem.default)(_designTokens.default.spacing.base * 1.5));
var JumpToLabel = (0, _styledComponents.default)(_Typography.P).attrs({
  as: 'span',
  size: 'small'
}).withConfig({
  displayName: "JumpToNav__JumpToLabel",
  componentId: "sc-1a5y6a1-2"
})(["margin-right:", ";"], (0, _rem.default)(_designTokens.default.spacing.base * 1.5));

function JumpToNav(props, forwardedRef) {
  var items = props.items,
      label = props.label,
      globalOffset = props.offset,
      rest = _objectWithoutProperties(props, ["items", "label", "offset"]);

  var translate = (0, _useTranslations.default)();
  return _react.default.createElement(_Flex.default, _extends({
    alignItems: "center",
    as: "nav",
    ref: forwardedRef
  }, rest), _react.default.createElement(JumpToLabel, null, translate(label, 'jumpTo.navLabel')), _react.default.createElement(JumpToOl, null, items.map(function (_ref) {
    var itemLabel = _ref.label,
        itemOffset = _ref.offset,
        selector = _ref.selector;
    return _react.default.createElement(JumpToLi, {
      key: itemLabel
    }, _react.default.createElement(_Button.default, {
      onClick: function onClick(event) {
        event.preventDefault();
        (0, _utils.jumpToSelector)(selector, globalOffset, itemOffset);
      },
      size: "small",
      text: itemLabel,
      variant: "ghost"
    }));
  })));
}

var JumpToNavWithRef = (0, _react.forwardRef)(JumpToNav); // @ts-ignore

JumpToNavWithRef.propTypes = _schema.default.propTypes;
var _default = JumpToNavWithRef;
exports.default = _default;